exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".interfejs{position:absolute;padding:.25em;border-radius:5px}.komande1,.komande2{top:30px}.komande1{left:30px}.komande2{right:30px}.progress-wrapper{position:relative}.progress{background-color:inherit;display:block;height:24px;width:100%}.energija{left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}.tabela{position:absolute;font-family:monospace;font-weight:700;text-shadow:1px 1px 5px #000;left:30px;top:30px;z-index:999;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./game-ui/css/50-interfejs.css
// module id = 28
// module chunks = 0